export const createApiError = (e?: any, showAlert = true) => ({
  code: e?.response?.status || 500,
  message: e?.response?.data?.message || 'Something goes wrong. Please try again',
  showAlert,
});
